import { gql } from '@apollo/client';

/**
 * GraphQL query to fetch attributes with their values
 */
export const GET_ATTRIBUTES_QUERY = gql`
  query GetAttributes {
    mst_attributes(
      where: {
        attribute_values_aggregate: {
          count: { predicate: { _gt: 0 } }
        }
      }
    ) {
      id
      name
      attribute_values {
        value
      }
    }
  }
`;

/**
 * GraphQL query to fetch categories with subcategories filtered by shop_id.
 */
export {
  GET_CATEGORIES_BY_LINK as GET_CATEGORIES_QUERY,
  GET_CATEGORIES_BY_LINK,
  GET_SHOP_CATEGORIES,
} from '@features/products/services/categoryCatalogService';

/**
 * GraphQL query to fetch Instagram reels from mst_post
 */
export const GET_INSTAGRAM_POSTS = gql`
  query GetInstagramPosts($shopId: uuid!) {
    mst_post(
      where: { shop_id: { _eq: $shopId } }
      order_by: { created_at: desc }
    ) {
      id
      thumbnail
      reel_url
      created_at
    }
  }
`;

/**
 * GraphQL query to fetch banners/sliders for the homepage
 */
export const GET_SLIDERS = gql`
  query GetSliders($shopId: uuid!) {
    mst_banner(
      where: { shop_id: { _eq: $shopId } }
      order_by: { created_at: desc }
    ) {
      id
      image
      shop_id
    }
  }
`;




